import React from 'react';
import { Group, Line, Text } from 'react-konva';
import { polygonArea, formatArea } from './floorPlanUtils';

function FloorPlanRoom({ room, walls, unit, zoom, isSelected, onSelect }) {
  // Build polygon from wall endpoints that form this room
  const vertices = room.vertices || [];
  if (vertices.length < 3) return null;

  // Flatten vertices into points array [x1, y1, x2, y2, ...]
  const points = vertices.flatMap(v => [v.x, v.y]);

  // Calculate centroid for label placement
  const cx = vertices.reduce((sum, v) => sum + v.x, 0) / vertices.length;
  const cy = vertices.reduce((sum, v) => sum + v.y, 0) / vertices.length;

  const area = polygonArea(vertices);
  const areaLabel = formatArea(area, unit);

  const fontSize = Math.max(10, 14 / zoom);

  return (
    <Group
      onClick={(e) => {
        e.cancelBubble = true;
        if (onSelect) onSelect(room.id);
      }}
      onTap={(e) => {
        e.cancelBubble = true;
        if (onSelect) onSelect(room.id);
      }}
    >
      {/* Room fill */}
      <Line
        points={points}
        closed
        fill={room.color || '#E8F0FE'}
        opacity={0.4}
        stroke={isSelected ? '#C4612E' : 'transparent'}
        strokeWidth={isSelected ? 1.5 / zoom : 0}
        dash={isSelected ? [6 / zoom, 3 / zoom] : undefined}
      />

      {/* Room label */}
      {room.label && (
        <Text
          x={cx}
          y={cy - fontSize}
          text={room.label}
          fontSize={fontSize}
          fontStyle="bold"
          fill="#555"
          align="center"
          offsetX={room.label.length * fontSize * 0.3}
        />
      )}

      {/* Area label */}
      <Text
        x={cx}
        y={cy + (room.label ? 2 : -fontSize / 2)}
        text={areaLabel}
        fontSize={fontSize * 0.85}
        fill="#888"
        align="center"
        offsetX={areaLabel.length * fontSize * 0.85 * 0.3}
      />
    </Group>
  );
}

export default React.memo(FloorPlanRoom);
